import { useSelector } from 'react-redux';
import { useRouteLoaderData } from 'react-router';
import { deepEqual } from '../../../../../common/utils/objectUtils';
import { pendingSubscriptionActionExistsInState } from '../../../../../common/utils/subscriptionUtils';
import { DeviceSubscriptionBasicDetails } from '../../../../../components/SubscriptionDetails/DeviceSubscriptionBasicDetails';
import { DeviceLayout } from '../../../../../components/SubscriptionLayout/DeviceLayout';
import type { DeviceSubscriptionLoaderResponse } from '../../../../../common/loaders';
import type { State } from '../../../../../selfservice/common/store';

export const DeviceBasicDetailsPath = () => {
  const {
    billingAccountRecordType,
    companyInfo,
    hasPendingActions,
    hasPendingAdminReview,
    subscription,
    subscriptionScheduledChanges,
  } = useRouteLoaderData('deviceSub') as DeviceSubscriptionLoaderResponse;
  const subscriptionActionsState = useSelector((s: State) => s?.selfservice?.pendingSubscriptionActions, deepEqual);
  return (
    <DeviceLayout companyInfo={companyInfo} subscription={subscription} hasPendingAdminReview={hasPendingAdminReview}>
      <DeviceSubscriptionBasicDetails
        subscription={subscription}
        hasPendingActions={
          hasPendingActions ||
          pendingSubscriptionActionExistsInState(subscription.subscriptionId, subscriptionActionsState)
        }
        hasScheduledChange={(subscriptionScheduledChanges?.subscriptionScheduledChangeResponses?.length ?? 0) > 0}
        companyInfo={companyInfo}
        billingAccountRecordType={billingAccountRecordType}
      />
    </DeviceLayout>
  );
};
